export const downloadItem = (contentType, fileContents, fileName) => {
  const url = `data:${contentType};base64,${fileContents}`;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

// export const downloadItemByURL = (url, fileName) => {
//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", fileName);
//   document.body.appendChild(link);
//   link.click();
//   link.parentNode.removeChild(link);
// };

export default downloadItem;